<template>
  <div>
    <m-list-output-fields></m-list-output-fields>
    <div class="summary-box" :class="{'summar-box-2':isUi2 }">
      <b-container fluid>
        <b-row v-if="!isUi2">
          <b-col class="summary-head">
            <h4>List Buy Order Information</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col clos="6" md="12">
            <p>Price Per Record: <span data-test="summary-info-perPrice">{{order.CostPrice | numberFormat('$', 5)}}</span></p>
            <p>Qty Available: <span data-test="summary-info-availableQty">{{order.TotalAvailableQty | numberFormat('', 0)}}</span></p>
            <p>Qty Selected: <span data-test="summary-info-selectedQty">{{order.TotalDesiredQty | numberFormat('', 0)}}</span></p>
            <p v-show="order.PromoCode !== ''">List Price:
              <span class="high"></span><span data-test="summary-info-listPrice">{{order.OrderCharge | numberFormat}}</span>
            </p>

            <p><span class="high">Total Price</span>:
              <span data-test="summary-info-totalPrice">{{order.TotalEstmCost | numberFormat}}</span> + Tax</p>

            <p v-show="order.CostPrice * order.TotalDesiredQty < $store.state.summary.UserPriceList.MinElementsCharge"
               style="margin-top: -12px"
               data-test="summary-info-minimumNotice">
              A minimum cost of {{$store.state.summary.UserPriceList.MinElementsCharge | numberFormat}} has been applied to your order. <br>
              You may expand your geographic area or your target audience to add approximately
              {{parseInt(order.TotalEstmCost/order.CostPrice - order.TotalDesiredQty + 1)}} more records at the same price per record, for the same total (minimum) cost.
            </p>

          </b-col>
          <b-col clos="6" md="12">
            <div v-show="showPromotion">
              <p size="sm">Promotion Code</p>
              <div class="promotion-form">
                <b-input placehodle="summer"
                         size="sm"
                         v-model.lazy.trim="promotionCode"
                         data-test="summary-info-promotionCode"
                         style="margin-bottom: 8px; max-width: 300px" />
                <b-btn @click="applyPromotionCode">Apply</b-btn>
              </div>
              <p v-show="showPromotionSuccess" class="promot-text">Has been promoted</p>
              <p v-show="showErrorPromotion" class="promot-text">Wrong Code</p>
            </div>

            <p v-show="order.PromoCode !== '' && order.PromotionAmount > 0"
               data-test="summary-info-promotionAmount">
              Promotion {{this.promotion.PromotionName}}:
              <span class="high"></span>-{{order.PromotionAmount | numberFormat}}
            </p>
            <p v-show="order.PromoCode !== '' && order.PromotionPoint > 0  && order.PromotionAmount === 0"
               data-test="summary-info-promotionPoint">
              Promotion {{this.promotion.PromotionName}}:
              <span class="high"></span>{{order.PromotionPoint}}
            </p>
            <p v-show="order.PromoCode !== '' && this.promotion.PromotionType === 6"
               data-test="summary-info-promotionType">
              Balance of {{promotion.PromotionName}}
              <span class="high"></span>:{{promotion.PromotionBalance | numberFormat}}
              <span style="color:Red;">(doesn't include current expenses)</span></p>

            <p v-if="$store.getters['summary/rewardsPoint'] > 0">Earned Points: {{$store.getters['summary/rewardsPoint'] | numberFormat('', 0)}}</p>
            <!--<p v-if="$store.getters['summary/bonusPoint'] > 0">Earned Bonus Points: {{$store.getters['summary/bonusPoint'] | numberFormat('', 0)}}</p>-->
          </b-col>
        </b-row>
        <b-row v-if="datasource.hasOutputFields" data-test="summary-info-hasOutput">
          <b-col>
            <b-link @click="showBreakdown">> See what's included in list output with option to add more info.</b-link>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
  import MListOutputFields from '@/components/summary/MListOutputFields'
  export default {
    components: {
      MListOutputFields
    },
    props: {
      isUi2: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        showPromotionSuccess: false,
        showErrorPromotion: false,
        promotionCodeInput: '',
        promotion: {PromotionName: 'text'}
      }
    },
    computed: {
      order () {
        return this.$store.state.order
      },
      promotionCode: {
        get () {
          this.promotionCodeInput = this.order.PromoCode || ''
          return this.order.PromoCode || ''
        },
        set (val) {
          this.promotionCodeInput = val
        }
      },
      showPromotion () {
        return true
        // return this.$store.getters['site/showPromotion']
      },
      datasource () {
        return this.$store.getters['config/datasource']
      }
    },
    methods: {
      applyPromotionCode () {
        this.showErrorPromotion = false
        this.$http.post('PlaceOrder.aspx/GetPromotion', {
          listtype: this.order.ListType,
          promotionCode: this.promotionCodeInput
        }).then(resp => {
          this.$store.commit('summary/saveKey', ['Promotion', resp.body.d.DataSource])

          if (resp.body.d.DataSource !== null) {
            this.$store.commit('order/saveKey', ['PromoCode', this.promotionCodeInput])
            this.promotion = resp.body.d.DataSource
          } else {
            this.showErrorPromotion = true
            this.$store.commit('order/saveKey', ['PromoCode', ''])
          }
          this.$store.dispatch('order/calculatePrice')
        }, resp => {
          this.promotionCodeInput = ''
          this.$store.commit('order/saveKey', ['PromoCode', this.promotionCodeInput])
          this.$store.commit('summary/saveKey', ['Promotion', resp.body.d.DataSource])

          // this.$store.dispatch('order/calculatePrice')
        })
      },
      showBreakdown () {
        this.$root.$emit('bv::show::modal', 'listoutputfields')
      }
    }
  }
</script>

<style scoped lang="scss">

  .more-output-link{
    font-size: 12px;
  }

  .promot-text{
    font-size: 13px;
    color: $color-primary-light
  }

  .promotion-form {
    display: flex;
  }

  .promotion-form .btn {
    margin-left: 24px;
  }
  .high {
    font-weight: bold;
    color: $color-primary
  }
</style>



// WEBPACK FOOTER //
// src/components/summary/MSummaryInfo.vue